import { computed, Ref } from 'vue'
import { type MultiselectOption, Tag } from '@ironsight/types'
import { usePaginatedTagsQuery } from '@/api/usePaginatedTagsQuery'

export function useTagsFilter(): { options: Ref<MultiselectOption[]> } {
  const { data: tags } = usePaginatedTagsQuery()

  const options = computed<MultiselectOption[]>(() => {
    const grouped = (tags.value ?? []).reduce(
      (acc, tag) => {
        const key = tag.displayString
        acc[key] = acc[key] || []
        acc[key].push(tag)
        return acc
      },
      {} as Record<string, Tag[]>,
    )

    return Object.values(grouped)
      .map((group) => ({
        label: group[0].displayString,
        value: group.map((tag) => tag.id).join(','),
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
  })

  return { options }
}
